module.exports = __webpack_public_path__ + "img/offline.5c0e0f4f.png";